const mjmlTemplate = `<mjml>
  <mj-head>
    <mj-attributes>
      <mj-all font-family="Inter, Arial, sans-serif" color="#3b4c56" />
      <mj-text font-size="15px" line-height="1.6" padding="0" />
      <mj-section padding="0" />
      <mj-column padding="0" />
    </mj-attributes>
    <mj-preview>
      {{preheaderText}}
    </mj-preview>
    <mj-style inline="inline">
      .markdown p + p { margin-top: 10px; }
      .markdown ul, .markdown ol { margin: 10px 0; padding-left: 20px; }
      .markdown li + li { margin-top: 6px; }
      .markdown a { color: inherit; text-decoration: underline; }
      .markdown strong { font-weight: 600; }
      .markdown em { font-style: italic; }
      .legal a { color: inherit !important; text-decoration: underline; }
      .legal-links a { cursor: pointer; }
      .social-icon {
        width: 30px !important; height: 30px !important; border-radius: 30px !important;
        background-color: rgba(255,255,255,0.7); display: inline-block;
      }
      .display-title-serif div {
        font-family: Inter, Arial, sans-serif !important;
        font-size: 30px !important;
        line-height: 1.25 !important;
        font-weight: 700 !important;
        letter-spacing: 0.08em !important;
        text-transform: uppercase !important;
        color: #000000 !important;
        text-align: center !important;
      }
      .cinematic-hero-image img {
        display: block !important;
        width: 100% !important;
        height: auto !important;
      }
      .cinematic-body div,
      .cinematic-body p {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 15px !important;
        line-height: 1.7 !important;
        letter-spacing: 0.04em !important;
        text-align: left !important;
      }
      .cinematic-footer-contact div,
      .cinematic-footer-contact p,
      .cinematic-footer-contact a {
        font-family: Georgia, 'Times New Roman', serif !important;
        font-size: 12px !important;
        line-height: 1.7 !important;
        text-align: center !important;
        color: #000000 !important;
      }
      .cinematic-footer-logo img {
        width: auto !important;
        max-width: 90px !important;
        height: auto !important;
        max-height: 60px !important;
        margin: 0 auto !important;
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#F8F8F3" width="600px">
    <mj-wrapper padding="0">
      <mj-section background-color="{{headerBgColor}}" padding="20px 30px" css-class="mjml-header">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0" width="{{logoWidth}}" height="{{logoHeight}}" css-class="mjml-logo" />
        </mj-column>
      </mj-section>

      <mj-section padding="0" css-class="mjml-hero" background-color="#F8F8F3">
        <mj-column>
          <mj-image src="{{heroImgUrl}}" alt="Hero" padding="0" href="{{heroImageLinkUrl}}" fluid-on-mobile="true" css-class="cinematic-hero-image" />
        </mj-column>
      </mj-section>

      <mj-section padding="30px 48px 20px" css-class="mjml-body" background-color="#F8F8F3">
        <mj-column>
          <mj-text css-class="display-title-serif" align="center" padding="0 0 20px 0">
            {{emailTitle}}
          </mj-text>
          <mj-text css-class="markdown cinematic-body" align="left" padding="0" line-height="1.7" font-size="15px">
            <!-- bodyHtml -->
          </mj-text>
          <mj-spacer height="20px" />
          <mj-button
            href="{{ctaUrl}}"
            background-color="transparent"
            color="{{ctaBackgroundColor}}"
            font-weight="600"
            font-size="12px"
            letter-spacing="0.12em"
            text-transform="uppercase"
            width="240px"
            align="center"
            padding="0"
            inner-padding="13px 22px"
            border-radius="0"
            border="1px solid {{ctaBackgroundColor}}"
            css-class="mjml-cta"
          >
            {{ctaText}}
          </mj-button>
        </mj-column>
      </mj-section>

      <mj-section padding="24px 44px 30px" css-class="mjml-footer" background-color="#F8F8F3">
        <mj-column>
          <mj-image src="{{logoUrl}}" alt="Logo" align="center" padding="0 0 22px 0" width="90px" css-class="cinematic-footer-logo" />
          <mj-text css-class="cinematic-footer-contact" align="center" padding="0 0 18px 0">
            <p style="margin:0 0 8px 0;">Book on <a href="{{hotelWebsiteUrl}}" style="color:#000000;text-decoration:underline;">{{hotelWebsite}}</a>, contact your travel professional or call us.</p>
            <p style="margin:0 0 4px 0;">{{hotelName}}: {{hotelAddress}}, {{hotelCityStateZip}}</p>
            <p style="margin:0;"><a href="tel:{{hotelPhone}}" style="color:#000000;text-decoration:underline;">{{hotelPhone}}</a></p>
          </mj-text>
          <mj-table align="center" padding="0">
            <tr>
              <td style="text-align: center;">
                <!-- socialMediaLinksHtml -->
              </td>
            </tr>
          </mj-table>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  </mj-body>
</mjml>`

export default mjmlTemplate
